import { gql } from '@apollo/client';

/** Shared `productTypeSpecific.healthQuestionnaire` selection for offers. */
export const HealthQuestionnaireOnOfferFragmentDoc = gql`
  fragment HealthQuestionnaireOnOffer on OfferProductTypeSpecificType {
    healthQuestionnaire {
      brandCode
      startedAt
      completedAt
      rejected
      isConfirmed
      answers {
        questionCode
        value
        followUpAnswers {
          fieldCode
          value
        }
      }
      messages {
        message
        type
        ruleCode
      }
    }
  }
`;
